/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Thu Apr 25 2024 08:13:29
 *
 *******************************************************/
//@flow

import React, { useEffect } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Icon } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';

type Props = {
  options: {
    message: string,
    actionContent: string,
    duration?: number
  },
  onAction: Function,
  onDismiss: Function
};

type ComposedProps = Props & WithI18nProps;

const ToastWithAction = (props: ComposedProps) => {
  const { options, onAction, onDismiss } = props;
  const { message, actionContent, duration = 10000 } = options;

  useEffect(() => {
    let timeoutId = null;

    // Use setTimeout to update the message after duration milliseconds
    if (message && message.trim().length > 0) {
      timeoutId = setTimeout(() => {
        onDismiss();
      }, duration);
    }

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timeoutId);

    // eslint-disable-next-line
  }, [message]);

  if (!message) return <></>;

  return (
    <div className="BC-Toast__Container">
      <div className="BC-Toast">
        <div className="BC-Toast__with-action">
          <div className="BC-Toast__item">{message}</div>
          <div
            className="BC-Toast__item BC-Toast__item-with-action"
            onClick={() => {
              onAction();
            }}>
            {actionContent}
          </div>
          <div
            className="BC-Toast__item BC-Toast__item-dismiss-btn"
            onClick={() => {
              onDismiss();
            }}>
            <Icon source={MobileCancelMajor} color="base" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withI18n()(ToastWithAction);
